export interface ITheme {
  name: string,
  body: string,
  headerBG: string,
  textColor: string,
  linkColor: string,
  linkHoverColor: string,
  fontFamily: string,
  textMuted: string,
  primaryColor: string,
  border: string,
  dashboardHeaderBG: string,
  dashboardRowBG: string,
  dashboardCompletedBG: string,
  dashboardCompletedTextColor: string,
  analyticsBG: string,
  analyticsBorder: string,
  cardBG: string,
  cardHeaderBG: string,
  buttonBG: string,
  buttonBorder: string,
  buttonTextColor: string,
  buttonBGHover: string,
  buttonBorderHover: string,
  buttonTextColorHover: string,
  navBG: string,
  navDropdownBG: string,
  navTextColor: string,
  navActiveTextColor: string,
  modalBG: string,
  modalBorder: string,
  switchOnBG: string,
  switchOnBorder: string,
  tableHeaderBG: string,
  pagerBG: string,
  pagerBorder: string,
  pagerTextColor: string,
  pagerNumberColor: string,
  tableBG: string,
  tableBorder: string,
  tableAltRowBG: string,
  invSideBarBG: string,
  invSideBarBorder: string,
  invSideBarDropdownActiveBG: string,
  invSideBarDropdownActiveBorder: string,
  invSideBarDropdownActiveBGHover: string,
  invSideBarNavLinkBG: string,
  invSideBarNavLinkBorder: string,
  invSideBarNavLinkBGHover: string,
  bgLight: string,
  bgWhite: string,
  textHightlight: string,
  bgImageButtonBG: string,
  chatBG: string,
  chatBorder: string,
  chatTextColor: string,
  chatToolBarBG: string,
  chatToolBarBorder: string,
  chatToolBarTextColor: string,
  tabstripContentBG: string,
  tabstripContentBorder: string,
  tabstripContentTextColor: string,
  disabledInputBG: string,
  pricingValuesBG: string,
  pricingValuesBorder: string,
  pricingValuesTextColor: string,
  gridButtonBG: string,
  gridButtonBorder: string,
  gridButtonTextColor: string,
  inputPrefixBG: string,
  sortableItemBG: string,
  infoAlertBG: string,
  infoAlertBorder: string,
  infoAlertTextColor: string,
  logsHighlightColor: string,
  buttonDefaultBG: string,
  buttonDefaultBorder: string,
  buttonDefaultColor: string,
  buttonDefaultHoverBG: string,
  buttonDefaultHoverBorder: string,
  buttonDefaultHoverColor: string,
  loginPageInputGroup: string,
}

export const darkTheme: ITheme = {
  name: 'dark',
  body: '#0c0c0c',
  headerBG: '#0c0c0c',
  textColor: '#fff',
  linkColor: '#fff',
  linkHoverColor: '#ccc',
  fontFamily: 'BlinkMacSystemFont, -apple-system, \'Segoe UI\', Roboto, Helvetica, Arial, sans-serif',
  textMuted: 'rgb(161 161 161 / 75%)',
  primaryColor: '#538efb',
  border: 'rgb(107 107 107)',
  dashboardHeaderBG: '#29292d',
  dashboardRowBG: '#222',
  dashboardCompletedBG: '#3d3d43',
  dashboardCompletedTextColor: '#fff',
  analyticsBG: '#222',
  analyticsBorder: '#000',
  cardBG: '#222',
  cardHeaderBG: '#29292d',
  buttonBG: '#538efb',
  buttonBorder: '#696969',
  buttonTextColor: '#fff',
  buttonBGHover: '#286090',
  buttonBorderHover: '#696969',
  buttonTextColorHover: '#fff',
  navBG: '#454545',
  navDropdownBG: '#696969',
  navTextColor: '#fff',
  navActiveTextColor: '#fff',
  modalBG: '#434343',
  modalBorder: 'rgb(123 123 123)',
  switchOnBG: '#538efb',
  switchOnBorder: '#696969',
  tableHeaderBG: '#222',
  pagerBG: '#222',
  pagerBorder: '#454545',
  pagerTextColor: '#fff',
  pagerNumberColor: '#fff',
  tableBG: '#494949',
  tableBorder: '#000',
  tableAltRowBG: 'rgb(0 0 0 / 20%)',
  invSideBarBG: '#0c0c0c',
  invSideBarBorder: '#6b6b6b',
  invSideBarDropdownActiveBG: '#222',
  invSideBarDropdownActiveBorder: '#000',
  invSideBarDropdownActiveBGHover: '#6b6b6b',
  invSideBarNavLinkBG: '#222',
  invSideBarNavLinkBorder: '#000',
  invSideBarNavLinkBGHover: '#777575',
  bgLight: '#222',
  bgWhite: '#313131',
  textHightlight: '#8b8b8b',
  bgImageButtonBG: '#fbfbfb',
  chatBG: '#222',
  chatBorder: '#797878',
  chatTextColor: '#fff',
  chatToolBarBG: '#222',
  chatToolBarBorder: '#797878',
  chatToolBarTextColor: '#fff',
  tabstripContentBG: '#222',
  tabstripContentBorder: '#797878',
  tabstripContentTextColor: '#fff',
  disabledInputBG: '#000',
  pricingValuesBG: '#0c0c0c',
  pricingValuesBorder: '#575757',
  pricingValuesTextColor: '#fff',
  gridButtonBG: '#181818',
  gridButtonBorder: 'rgb(107 107 107)',
  gridButtonTextColor: '#fff',
  inputPrefixBG: '#181818',
  sortableItemBG: 'rgb(107 107 107)',
  infoAlertBG: '#0c0c0c',
  infoAlertBorder: '#575757',
  infoAlertTextColor: '#fff',
  logsHighlightColor: '#737373',
  buttonDefaultBG: 'rgb(105, 105, 105)',
  buttonDefaultBorder: 'rgb(105, 105, 105)',
  buttonDefaultColor: 'rgb(255, 255, 255)',
  buttonDefaultHoverBG: 'rgb(69, 69, 80)',
  buttonDefaultHoverBorder: 'rgb(105, 105, 105)',
  buttonDefaultHoverColor: 'rgb(255, 255, 255)',
  loginPageInputGroup: '#181818'
}

export const lightTheme: ITheme = {
  name: 'light',
  body: '#fff',
  headerBG: '#222',
  textColor: '#222',
  linkColor: '#0d6efd',
  linkHoverColor: '#0a58ca',
  fontFamily: 'BlinkMacSystemFont, -apple-system, \'Segoe UI\', Roboto, Helvetica, Arial, sans-serif',
  textMuted: 'rgba(33, 37, 41, 0.75)',
  primaryColor: '#0d6efd',
  border: 'rgba(0, 0, 0, .125)',
  dashboardHeaderBG: '#4776B5',
  dashboardRowBG: '#f5f5f5',
  dashboardCompletedBG: '#D9EDF7',
  dashboardCompletedTextColor: '#31708F',
  analyticsBG: '#e0e0e0',
  analyticsBorder: '#a2a2a2',
  cardBG: '#fff',
  cardHeaderBG: '#F5F5F5',
  buttonBG: '#fff',
  buttonBorder: 'rgba(0, 0, 0, .125)',
  buttonTextColor: '#333',
  buttonBGHover: '#e6e6e6',
  buttonBorderHover: '#adadad',
  buttonTextColorHover: '#333',
  navBG: '#f8f9fa',
  navDropdownBG: '#fff',
  navTextColor: '#777',
  navActiveTextColor: '#777',
  modalBG: '#fff',
  modalBorder: 'rgba(0, 0, 0, .125)',
  switchOnBG: '#0d6efd',
  switchOnBorder: 'rgba(0, 0, 0, .125)',
  tableHeaderBG: '#f8f9fa',
  pagerBG: '#f8f9fa',
  pagerBorder: 'rgba(0, 0, 0, .125)',
  pagerTextColor: '#212529',
  pagerNumberColor: '#0d6efd',
  tableBG: '#fff',
  tableBorder: 'rgba(0, 0, 0, .125)',
  tableAltRowBG: 'rgba(0, 0, 0, 0.04)',
  invSideBarBG: '#f8f8f8',
  invSideBarBorder: 'rgba(0, 0, 0, .125)',
  invSideBarDropdownActiveBG: '#eee',
  invSideBarDropdownActiveBorder: 'rgba(0, 0, 0, .125)',
  invSideBarDropdownActiveBGHover: '#e5e5e5',
  invSideBarNavLinkBG: '#eee',
  invSideBarNavLinkBorder: 'rgba(0, 0, 0, .125)',
  invSideBarNavLinkBGHover: '#e5e5e5',
  bgLight: '#f8f9fa',
  bgWhite: '#fff',
  textHightlight: '#ffff00',
  bgImageButtonBG: '#fff',
  chatBG: '#fafafa',
  chatBorder: 'rgba(0, 0, 0, .125)',
  chatTextColor: '#212529',
  chatToolBarBG: '#f8f9fa',
  chatToolBarBorder: 'rgba(0, 0, 0, .125)',
  chatToolBarTextColor: '#212529',
  tabstripContentBG: '#fff',
  tabstripContentBorder: 'rgba(0, 0, 0, .125)',
  tabstripContentTextColor: '#212529',
  disabledInputBG: '#e9ecef',
  pricingValuesBG: '#fff',
  pricingValuesBorder: '#dee2e6',
  pricingValuesTextColor: '#000',
  gridButtonBG: '#fff',
  gridButtonBorder: '#ccc',
  gridButtonTextColor: '#6c757d',
  inputPrefixBG: '#e9ecef',
  sortableItemBG: '#f8f9fa',
  infoAlertBG: '#cff4fc',
  infoAlertBorder: '#9eeaf9',
  infoAlertTextColor: '#055160',
  logsHighlightColor: '#ffffd3',
  buttonDefaultBG: 'rgb(255, 255, 255)',
  buttonDefaultBorder: 'rgba(0, 0, 0, 0.125)',
  buttonDefaultColor: 'rgb(51, 51, 51)',
  buttonDefaultHoverBG: 'rgb(230, 230, 230)',
  buttonDefaultHoverBorder: 'rgb(173, 173, 173)',
  buttonDefaultHoverColor: 'rgb(51, 51, 51)',
  loginPageInputGroup: '#eee'
}
